import { addAllInputChangeDetections, removeAllInputChangeDetections } from '../../helpers/validators/validate.js';
import { deleteAlert } from '../../services/alerts.service.js';
import { deleteAsset } from '../../services/assets.service.js';
import { registerDeleteAssetEvents } from '../portfolioAssetDialogs/deleteAsset.dialog.events.js';
export function killProcessingDialog() {
	var btns = $(".dialog-btn");
	$("body,html").toggleClass("wait");
	$(btns).each(function() {
		$(this).removeClass('disable');
		$(this).prop('disabled', false);
	})
}

export function feedbackProcessingDialog() {
	var btns = $(".dialog-btn");
	$("body,html").toggleClass("wait");
	$(btns).each(function() {
		$(this).addClass('disable');
		$(this).prop('disabled', true);
	})
}

export function wadialog(header, text, buttons, callback, _scripts, dataObj, closeByKeyboard = false, closeByBackdrop = false, dialog_cssClass = '') {
	return new Promise(function (resolve, reject) {
		var _buttons = new Array;

		for (var i=0;i<buttons.length;i++) {

			var cssClass = 'd-none d-md-inline btn-outline-secondary dialog-btn modal-cancel-btn';
			if (!!buttons[i] && buttons[i].action == "save") cssClass = 'ml-2 btn-success dialog-btn modal-create-btn';
			if (!!buttons[i] && (buttons[i].action == "delete" || buttons[i].action == "delete_asset")) cssClass = 'ml-2 btn-outline-danger dialog-btn modal-delete-btn';
			if (!buttons[i]) cssClass = "d-none";

			cssClass += " col-4 col-md-3 col-lg-3 col-xl-3";

			var __callback = function() {
				removeAllInputChangeDetections();
				BootstrapDialog.closeAll();
		
			}
			if (!!buttons[i] && (buttons[i].action == "save" || buttons[i].action == "delete_asset"))
				__callback = function() {
					callback(dataObj);
				}

			if (!!buttons[i] && buttons[i].action == "delete") {
				__callback = function() {
					if (dataObj.assetid !== undefined && dataObj.alertid === undefined) {
						var assetid = dataObj.assetid;
						var _assetid = -1;
						for (var i = 0; i < userassets.length; i++) {
							if (userassets[i].id == assetid) _assetid = i;
						}
						var dialog_html = template_deleteAsset_dialog;
						var buttons_obj = [{action: "abort", title: I18n["button_abort"]}, {action: "delete_asset", title: I18n["button_delete"]}]
						wadialog(I18n["delete_asset_header"], dialog_html, buttons_obj, deleteAsset, registerDeleteAssetEvents, _assetid);							
					}
					if (dataObj.alertid !== undefined) {
						deleteAlert(dataObj);
					}
				}
			}
			
			var title = !!buttons[i] ? buttons[i].title : '';
			
			_buttons[i] = {
				label: title,
				cssClass: cssClass,
				action: __callback
				
			}
			
		}
		BootstrapDialog.closeAll();
		BootstrapDialog.show({
			title: header,
			message: text,
			closeByBackdrop: closeByKeyboard,
            closeByKeyboard: closeByBackdrop,
			cssClass: dialog_cssClass,
			onshown: function (dialogRef) {
				var ref_object = $(dialogRef.relatedTarget);
				if (!!_scripts) _scripts(ref_object, dataObj);
				addAllInputChangeDetections();
				resolve();
			},
			onhide: function (dialogRef) {
			},
			buttons: _buttons
		});
	});
}